var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.74223C3.75 3.01385 3.75 2.64967 3.90187 2.44891C4.03417 2.27402 4.23639 2.1658 4.4553 2.15273C4.70658 2.13772 5.0096 2.33974 5.61564 2.74376L13.5023 8.00154C14.0031 8.33539 14.2535 8.50231 14.3407 8.7127C14.417 8.89664 14.417 9.10337 14.3407 9.28731C14.2535 9.4977 14.0031 9.66462 13.5023 9.99846L5.61564 15.2562C5.0096 15.6603 4.70658 15.8623 4.4553 15.8473C4.23639 15.8342 4.03417 15.726 3.90187 15.5511C3.75 15.3503 3.75 14.9862 3.75 14.2578V3.74223Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.535468dd23c9291e3b0f2fe6321340b2.svg";
export { ForwardRef as ReactComponent };